import { z } from 'zod';

// 6.8 "Deny access" — the reason is mandatory: it is the message the seller
// reads, and the platform's own record of why the item was removed.
export const MARKETPLACE_ACCESS_DENIAL_REASON_MAX = 1000;

export const DenyMarketplaceAccessDto = z
  .object({
    reason: z.string().trim().min(1).max(MARKETPLACE_ACCESS_DENIAL_REASON_MAX),
  })
  .strict();
export type ApiDenyMarketplaceAccessDto = z.infer<
  typeof DenyMarketplaceAccessDto
>;

export type ApiMarketplaceAccessDenial = {
  id: string;
  /** Seller identity: an organization, or an org-less personal profile. */
  organizationId: string | null;
  organizationName: string | null;
  userId: string | null;
  userName: string | null;
  reason: string;
  createdAt: string;
  /** NULL while the denial is active. */
  restoredAt: string | null;
};
